import { createContext } from "react";

const DF_LO0003Context = createContext();

export {DF_LO0003Context}
